module.exports = __webpack_public_path__ + "media/src/images/icon/play-242fb58384bf35124895595670787c98.png";